<script>
import apiServices from "../../../api/services";

import { GetDataRequest, FilterColumn } from "../../../components/table";
import { SERVICE_TYPE_TAG_ID } from "../../constants";

import CategoryField from "./CategoryField";
import { mapGetters } from "vuex";

export default {
  extends: CategoryField,
  computed: {
    ...mapGetters("auth", ["currentWorkShopId"]),
  },
  methods: {
    async loadItems(category_id) {
      const request = new GetDataRequest({
        perPage: 1000,
      });
      request.filterData = [
        new FilterColumn("services.tag_id", category_id, "="),
        new FilterColumn("services.is_active", 1, "="),
      ];
      const { data } = await apiServices.getServices(this.currentWorkShopId, {
        ...request,
        tag_type: SERVICE_TYPE_TAG_ID,
      });
      return data.data;
    },
  },
};
</script>